import React from "react";
import Typewriter from "typewriter-effect";
import videoBg from "../videos/home.mp4";
import videoIm from "../videos/home.jpg";

/* 
console.log(videoIm); */

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-purple-dk" />

        {/* ---------------image background------------------ */}
{/*        <div
          className="hero-bg parallax"
          style={{ backgroundImage: 'url("images/intro-bg.jpg")' }}
        ></div>
 */}
        {/* -------------------video background---------------------- */}


        { <div className="player hero-bg parallax">
          <video 
            poster={videoIm}
            src={videoBg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div> }

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-9  fw-500 text-white mb-2 mb-md-3">Welcome</p>
                <h2 className="text-18 fw-700 text-white mb-2 mb-md-3">
                  <Typewriter
                    options={{
                      strings: [
                        "I'm <span style='color: #FFC002';>Kevon Greene</span>",
                        "I'm a <span style='color: #FFC002';>Front-End Developer</span>",
                        "I'm a <span style='color: #FFC002';>UX/UI Designer</span>",
                      ],
                      autoStart: true,
                      loop: true,
                    }} 
                  />
                </h2>
                <p className="text-5 text-light mb-4">
                  based in Atlanta, Georgia.
                </p>
                <a
                  href="#contact"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("portfolio");
                  }}
                >
                  See My Portfolio
                </a>
              </div>
            </div>
          </div>
          <a
            href="#portfolio"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("portfolio");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
